import { ClientField } from 'components';
import { lodash } from 'helpers';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { useOrderContext } from 'modules/order/order/providers/OrderProvider';

import { OrderSection } from '../../OrderSection';

export const MainInformationSection = () => {
  const { t } = useTranslation();

  const isEditable = useIsFormEditable();

  const { order } = useOrderContext();

  return (
    <OrderSection
      fields={lodash.compact([
        {
          label: 'ID',
          value: order.id,
        },
        {
          label: t(
            'order.sections.mainInformationSection.fields.orderType.label'
          ),
          value: t(`order.orderTypes.${order.orderType}`),
        },
        {
          label: t('order.sections.mainInformationSection.fields.number.label'),
          value: order.number,
        },
        {
          label: t(
            'order.sections.mainInformationSection.fields.operationType.label'
          ),
          value: t(`order.operationTypes.${order.operationType}`),
        },
        <ClientField
          clientId={order.owner.id}
          clientName={order.owner.fullName ?? ''}
          clientType={order.owner.type}
          disabled={isEditable}
          label={t(
            'order.sections.mainInformationSection.fields.clientName.label'
          )}
        />,
        {
          label: t(
            'order.sections.mainInformationSection.fields.clientAccountNumber.label'
          ),
          value: order.owner.accountNumber,
        },
      ])}
      title={t('order.sections.mainInformationSection.title')}
    />
  );
};
